import { MarkdownRenderer } from './MarkdownRenderer';

export const MarkdownRendererModule = {
  __init__: ['markdownRenderer'],
  markdownRenderer: ['type', MarkdownRenderer],
};

export { MarkdownRenderer };
